import { HttpClient } from '@wix/http-client';
import { queryLibraryFolderItems } from '@wix/ambassador-file-sharing-v1-library-item/http';
import { getInstance } from '../Services/Instance.service';

export class EditorFileSharingService {
  private editorFileSharingService: HttpClient | null = null;
  instance: string = '';
  constructor() {
    getInstance().subscribe((data: string) => {
      this.instance = data;
      if (this.instance) {
        this.editorFileSharingService = new HttpClient({
          baseURL: 'https://editor.wixapps.net/',
          headers: { Authorization: this.instance },
        });
      }
    });
  }

  getAllFolders = async () => {
    if (!this.editorFileSharingService) {
      throw new Error('EditorFileSharingService not initialized');
    }
    const allLibraryItems: any[] = [];

    const firstResult = await this.editorFileSharingService.request(
      queryLibraryFolderItems({}),
    );
    allLibraryItems.push(...(firstResult.data.libraryItems ?? []));
    let cursor = firstResult.data.metaData?.nextCursor;

    while (cursor) {
      const nextResult = await this.editorFileSharingService.request(
        queryLibraryFolderItems({ paging: { cursor } }),
      );
      allLibraryItems.push(...(nextResult.data.libraryItems ?? []));
      cursor = nextResult.data.metaData?.nextCursor;
    }

    return {
      ...firstResult,
      data: { ...firstResult.data, libraryItems: allLibraryItems },
    };
  };
}
